import { NODES_BASE_KEY } from '@/api/nodes/helpers/base-key'
import { toast } from '@/features/toast/toast'
import { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import {
    IOrganizationRenameNodeRequestBody,
    IOrganizationRenameNodeResponseData,
} from 'api/dist/routes/organization/[organization_id]/brands/[brand_slug]/nodes/node/rename'

interface IRenameNodeMutationParams {
    organizationId: string
    brandSlug: string
}

export class DeleteNodeMutation {
    static call(
        api: IApi,
        { organizationId, brandSlug, ...payload }: IRenameNodeMutationParams & IOrganizationRenameNodeRequestBody
    ) {
        return api.put<IOrganizationRenameNodeResponseData, IOrganizationRenameNodeRequestBody>(
            `/organization/${organizationId}/brands/${brandSlug}/nodes/node/rename`,
            payload
        )
    }
}

export const useRenameNodeMutation = () => {
    const { api, apiParams, qc } = useApiToolbox()

    return useApiMutation({
        mutationFn: (payload: IOrganizationRenameNodeRequestBody) => {
            const promise = DeleteNodeMutation.call(api, {
                ...payload,
                organizationId: apiParams.organizationId,
                brandSlug: apiParams.brandSlug,
            })

            return promise.then((res) => {
                // Invalidation promise must be returned
                return qc
                    .invalidateQueries({
                        predicate: (query) => NODES_BASE_KEY.every((key, i) => query.queryKey[i] === key),
                    })
                    .finally(() => {
                        return res
                    })
            })
        },
        onError: () => {
            toast.error('Failed to rename node, try again or with another name')
        },
    })
}
